import { required } from 'vuelidate/lib/validators';
import Captcha from '@/components/common/captcha/Captcha.vue'

export default {
  data: function () {
    return {
      password: '',
      name: '',
      error: null,
      loading: false,
      captcha: { }
    }
  },
  components: {
    Captcha
  },
  validations: {
    name: { required },
    password: { required }
  },
  methods: {
    login (name, password) {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const self = this;

        const reqData = {
          username: this.name,
          password: this.password,
          device: {
            id: this.generateUidd(),
            name: navigator.userAgent
          },
          locale: this.$i18n.locale,
          captcha_value: this.captcha.value,
          captcha_key: this.captcha.key
        };

        this.ApiRequest.request('login', this.ApiRequest.REQUEST_POST, reqData, function (response) {
          if (response.captcha) {
            self.$refs.captchainput.resetCaptcha(response.captcha);
          }
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$session.start();
            self.$session.set('accessToken', response.data.token);
            self.$session.set('uuid', response.data.user.api_id);
            self.$session.set('user', response.data.user.name);
            self.$session.set('email', response.data.user.email);
            self.$session.set('locale', response.data.user.defaultLang);
            self.$session.set('permissions', response.data.user.permissions);
            self.$session.set('client_permissions', response.data.user.client_permissions);
            self.$session.set('roles', response.data.user.roles.map(a => a.name));
            self.$session.set('isSimUser', false);
            self.$session.set('version', response.data.version);
            self.$root.$i18n.locale = response.data.user.defaultLang;
            self.$store.dispatch('reloadConfig', { force: true });
            self.$store.dispatch('sessionUpdated');
            self.$store.dispatch('loadTranslations');
            self.$router.push('/home');
          }
          self.$v.$reset();
          self.password = '';
          self.loading = false;
        });
      }
    },
    generateUidd () {
      let d = new Date().getTime();
      if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now();
      }
      const newGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });

      return newGuid;
    },
    getLoadingClasses () {
      if (this.loading) {
        return 'disabled';
      }
      return '';
    }
  }
}
